<div class="page-layout tw-flex tw-flex-col tw-gap-2 tw-h-full tw-break-words tw-whitespace-normal"
     id="redesignmaincontent"
     tabindex="-1"
     role="main"
     #pageContainer
>
    <div class="page-layout__header tw-flex tw-flex-col md:tw-flex-row tw-gap-2 tw-w-full">
        <div class="tw-flex tw-items-start" *ngIf="showBackButton">
            <p-button
                (onClick)="onBackClick()"
                variant="outlined"
                icon="pi pi-chevron-left"
                size="small"
                [ariaLabel]="'pageLayout.backButton.ariaLabel' | transloco"
            />
        </div>
        <div class="tw-flex tw-flex-col tw-flex-1">
            <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap md:tw-flex-nowrap">
                <ng-content select="[header]"></ng-content>
                <h1 class="op-page-header" *ngIf="header && !hasHeaderContent">{{ header }}</h1>
                <span class="tw-ml-auto tw-shrink-0">
                    <ng-content select="[header-end]"></ng-content>
                </span>
            </div>
            <div class="op-page-sub-header">
                <ng-content select="[subheader]"></ng-content>
                <span *ngIf="subheader && !hasSubheaderContent">{{ subheader | stripHtml }}</span>
                <div class="tw-mt-2">
                    <ng-content select="[subheader-extra]"></ng-content>
                </div>
            </div>
        </div>
    </div>

    <div class="page-layout__content" [ngClass]="{'op-single-column-form-layout-width': formLayout === 'single-column'}">
        <ng-content></ng-content>
    </div>
</div>
